{
	"label": "Categories",
	"addAll": "Add all",
	"removeAll": "Remove all"
}
